import { render, staticRenderFns } from "./WishlistBox.vue?vue&type=template&id=c9ed549c&scoped=true"
import script from "./WishlistBox.vue?vue&type=script&lang=js"
export * from "./WishlistBox.vue?vue&type=script&lang=js"
import style0 from "./WishlistBox.vue?vue&type=style&index=0&id=c9ed549c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ed549c",
  null
  
)

export default component.exports